import clsx from 'clsx';
import { withStyles } from '@material-ui/core/styles';

const styles = ({ palette }) => ({
  root: {
    background: palette.cncUI.default['+8'],
    color: palette.cncUI.default.primary,
    width: 32,
    height: 32,
    display: 'block',
    lineHeight: '32px',
    borderRadius: 4,
  },
  short: {
    width: 24,
    height: 24,
    lineHeight: '24px',
  },
});

const Priority = ({ classes, children, short = false }) => (
  <span className={clsx(classes.root, short && classes.short)}>{children}</span>
);

export default withStyles(styles)(Priority);
